/**
 * FireCore-Icons: isometrische PNGs, sonst Material-Fallback.
 */
import React from 'react';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import EventNoteRoundedIcon from '@mui/icons-material/EventNoteRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import ReplyRoundedIcon from '@mui/icons-material/ReplyRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import MonitorHeartRoundedIcon from '@mui/icons-material/MonitorHeartRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import InboxRoundedIcon from '@mui/icons-material/InboxRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const isoContext = require.context('../images/icons', false, /\.png$/);
const ISOMETRIC = {};
isoContext.keys().forEach((key) => {
  const name = key.replace(/^\.\//, '').replace(/\.png$/, '');
  ISOMETRIC[name] = isoContext(key);
});

const FALLBACK = {
  chevron: ChevronRightRoundedIcon,
  calendar: EventNoteRoundedIcon,
  tune: TuneRoundedIcon,
  send: SendRoundedIcon,
  reply: ReplyRoundedIcon,
  close: CloseRoundedIcon,
  ok: CheckCircleRoundedIcon,
  alarm: ErrorRoundedIcon,
  status: MonitorHeartRoundedIcon,
  confirmed: TaskAltRoundedIcon,
  mail: MailOutlineRoundedIcon,
  inbox: InboxRoundedIcon,
  events: NotificationsActiveRoundedIcon,
  warning: WarningAmberRoundedIcon,
};

export const Icons = { ...FALLBACK };

export function Icon({ name, size = 22, sx, className = '', alt = '', ...rest }) {
  const src = ISOMETRIC[name];
  const dim = typeof size === 'number' ? size : 22;

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={`fc-iso-icon ${className}`.trim()}
        width={dim}
        height={dim}
        draggable={false}
        style={{ width: dim, height: dim }}
        {...rest}
      />
    );
  }

  const Cmp = FALLBACK[name];
  if (!Cmp) return null;
  return <Cmp className={className} sx={{ fontSize: dim, ...sx }} {...rest} />;
}

export function IconWell({ name, tone = 'accent', size = 28 }) {
  return (
    <span className={`fc-icon-well is-${tone}${ISOMETRIC[name] ? ' is-iso' : ''}`}>
      <Icon name={name} size={size} />
    </span>
  );
}
